export const DATE_PICKER_VARIANTS = {
  FIELD: 'field',
  ICON: 'icon',
};

export const DATE_PICKER_CELL_VARIANTS = {
  DEFAULT: 'default',
  RANGE_START: 'range-start',
  RANGE_MIDDLE: 'range-middle',
  RANGE_END: 'range-end',
  OUTSIDE: 'outside',
  OUTSIDE_RANGE_START: 'outside-range-start',
  OUTSIDE_RANGE_MIDDLE: 'outside-range-middle',
  OUTSIDE_RANGE_END: 'outside-range-end',
  SPACER: 'spacer',
};
